export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_antd@3.1.4@antd/es/form/constants.js
// module id = null
// module chunks = 